import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { IAppPage } from 'src/interface';
import { pageSelector } from 'src/selectors/app';
import { strUserIdSelector } from 'src/selectors/auth';
import { trackingContent } from 'src/utils/tracking';

export const useTracking = (contentId: number, source: string = '') => {
    const page: IAppPage = useSelector(pageSelector);
    const strUserId = useSelector(strUserIdSelector);
    const router = useRouter();
    const isTrigger = useRef<boolean>(false);
    const [inViewRef, inView] = useInView({ threshold: 1 });

    router.events?.on('routeChangeComplete', () => {
        isTrigger.current = false;
    });

    useEffect(() => {
        if (inView && source && !isTrigger.current) {
            let _source = `${source}`;

            if (source.substring(0, 1) === '|') {
                let catePath = '';
                if (source.indexOf('detail') < 0) {
                    catePath = page.type;
                }
                _source = catePath + _source;
            }

            trackingContent(_source, contentId, strUserId);
            isTrigger.current = true;
        }
    }, [inView, page]);

    return inViewRef;
};
